import Styles from "./AppSlider.module.scss"


//Redux 
import { useDispatch } from "react-redux";
import { turnOffDrag, turnOnDrag } from "../../actions";


interface AppSliderProps {
    minLabel?: string;
    maxLabel?: string;
    currentVal: number;
    minValue: number;
    maxValue: number;
    title: string;
    onChange: (data: any) => void;
}

const AppSlider = (
    {
        minLabel,
        maxLabel,
        currentVal,
        minValue,
        maxValue,
        title,
        onChange
    }: AppSliderProps
) => {

    const dispatch = useDispatch()

    const handleChange = (e: any) => {
        onChange(e.target.value)
    }

    return (
        <div className={Styles.container}  >
            <div className={Styles.heading}>
                {title}
            </div>
            <div className={Styles.app_slider}>
                <input step={.5} onMouseOver={() => { dispatch(turnOffDrag()) }} onMouseOut={() => { dispatch(turnOnDrag()) }} onChange={handleChange} type="range" min={minValue} max={maxValue} value={currentVal} className={Styles.slider} name={title} id={title} />
            </div>
            {minLabel || maxLabel &&
                <div className={Styles.min_max}>
                    <div>{minLabel}</div>
                    <div>{maxLabel}</div>
                </div>
            }
        </div>
    )
}

export default AppSlider
